import { createRequestTypes } from '../utils';

export const PRODUCT_CATEGORY_TR_LIST = createRequestTypes('productCategoryTR/PRODUCT_CATEGORY_TR_LIST');
export const SAVE_PRODUCT_CATEGORY_TR = createRequestTypes('productCategoryTR/SAVE_PRODUCT_CATEGORY_TR');

